module.exports = __webpack_public_path__ + "static/img/product3-1.96ddb2e6.png";